import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchMarketData(payload) {
  try {
    const url = paths.getMarketList();
    const response = await axiosInstance.post(url, payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useFetchMarketData = () => {
  return useMutation({
    mutationFn: fetchMarketData,
  });
};

export { useFetchMarketData };
